var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"visible":_vm.show,"show-close":false},on:{"update:visible":function($event){_vm.show=$event}}},[_c('div',{staticClass:"content"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }